export const getJsonOutputFormatting = (propertyName = 'output', exampleJsonString = '{}', additionalContent) =>
  `The reply must contain exactly one property called ${propertyName}. Format the reply as valid JSON according to this example. Before returning the response, verify that the output is valid JSON using a JSON parser (e.g., JSONLint or JSON.parse in JavaScript).${additionalContent ? ' ' + additionalContent : ''}
\`\`\`json
${exampleJsonString}
\`\`\``

export const getJsonArrayOutputFormatting = (exampleJsonString = '{}', additionalContent) =>
  `Format the reply as valid JSON according to this example. Before returning the response, verify that the output is valid JSON using a JSON parser (e.g., JSONLint or JSON.parse in JavaScript).${additionalContent ? ' ' + additionalContent : ''}
\`\`\`json
${exampleJsonString}
\`\`\``
